import axios from "../../service";
import fn from "@/helpers/utility";
import alert from "@/_helpers/alert";
import { CreditService } from '../resources'


export const state = {
  selectStore: {},
  storeByid:{},
  storeOtherFeeSelect:null,

//   couponList: {
//     report: [],
//     total: 0
//   },
  keyAuth: {
    key: "credit_flag",
    keyAdvance: "advanced_credit_flag"
  },
};

export const mutations = {
//   INIT_COUPON_LIST(state, newValue) {
//     if (newValue.length == 0) {
//       state.couponList.report = newValue;
//       state.couponList.total = newValue.length;
//     } else {
//       for (let index = 0; index < newValue.report.length; index++) {
//         if (newValue.report[index].email === null) {
//           newValue.report[index].email = "-";
//         }
//         if (newValue.report[index].partner_name === null) {
//           newValue.report[index].partner_name = "-";
//         }
//         newValue.report[index].used_amount =
//           newValue.report[index].limit_amount -
//           newValue.report[index].used_amount;
//       }
//       state.couponList = newValue;
//     }
//   },


  INIT_SET_STORE_SELECT(state, newValue) {
    state.selectStore = newValue;
  },
  INIT_SET_STORE_BYID(state, newValue) {
    state.storeByid = newValue;
  },
  INIT_OTHER_SELECT(state, newValue) {
    state.storeOtherFeeSelect = newValue;
  }  
};

export const getters = {
  PermissionFlagCredit(state) {
    // return '999'
    return  fn.PermissionFlag(state.keyAuth.key, state.keyAuth.keyAdvance);
  }
};

export const actions = {

  async getCredit({ commit }, id) {
    try {
      let resp = await CreditService.apiGetCredit(id)
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getCreditByid({ commit }, id) {
    try {
      let resp = await CreditService.apiGetCreditByid(id)
      return { status: true, data:resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },
  async getInvoiceShipmentOrder({ commit }, data) {
    try {
      let resp = await CreditService.apiGetInvoiceShipmentOrder(data)
      return { status: true, data:resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async cancelCredit({ commit }, data) {
    try {
      let resp = await CreditService.apiEditCancelCredit(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  

  async approveCredit({ commit }, data) {
    try {
      let resp = await CreditService.apiCreateApproveCredit(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getDebt({ commit }, data) {
    try {
      let resp = await CreditService.apiGetDebt(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },


  async getDebtByid({ commit }, id) {
    try {
      let resp = await CreditService.apiGetDebtByid(id)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getBank({ commit }, id) {
    try {
      let resp = await CreditService.apiGetBank()
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async approveCreditCreate({ commit }, data) {
    try {
      let resp = await CreditService.apiCreateApproveCreate(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },
  

  async creditNoteByid({ commit }, id) {
    try {
      let resp = await CreditService.apiGetCreditNoteByid(id)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async createCreditNoteDown({ commit },id){
    try {
        let resp = await CreditService.apiCreateCreditNoteDown(id)
        return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },


  async getCheckCreditOrder({ commit },data){
    try {
        let resp = await CreditService.apiGetCheckCreditOrder(data)
        return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },

  async getCheckCreditSummary({ commit },data){
    try {
      let resp = await CreditService.apiGetCheckCreditSummary(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },


  async getOtherFeeAll({ commit },data){
    try {
      let resp = await CreditService.apiGetOtherFeeAll(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },
  

  async getOtherFeeSummary({ commit },data){
    try {
      let resp = await CreditService.apiGetOtherFeeSummary(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },

  async getOtherFeeByid({ commit },data){
    try {
      let resp = await CreditService.apiGetOtherFeeByid(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },


  async createOtherFee({ commit },data){
    try {
      let resp = await CreditService.apiCreateOtherFee(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },


  async approveOtherByid({ commit },data){
    try {
      let resp = await CreditService.apiEditApproveOtherByid(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },

  async approveMultiService({ commit },data){
    try {
      let resp = await CreditService.apiEditApproveMultiService(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },

  async updateOtherFee({ commit },data){
    try {
      let resp = await CreditService.apiEditOtherFee(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },


  async deleteOtherFee({ commit },data){
    try {
      let resp = await CreditService.apiDeleteOtherFee(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },
  
  async createDisplayCredit({ commit },data){
    try {
      let resp = await CreditService.apiCreateDisplayCredit(data)
      return { status: resp?.status == false ? false : true, data:resp };
    } catch (err) {
        return { status: false, err: err };
    }
  },


  async creditNoteGetLink({ commit }, id) {
    try {
      let resp = await CreditService.apiGetCreditNoteGetLink(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },


  
//   /v1/invoice-approvals/:id/shipment-orders
  



  async exportExcelApi({ commit }, id) {
    try {
        let resp = await axios({
            method: "GET",
            url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/invoice-approvals/${id}/invoice-approvable/export`,
            headers: {
                Authorization:`Bearer ${localStorage.getItem('token')}`,
                Accept: "application/json", 
            },
            timeout: 300000,
            maxContentLength: 1073741824,
            responseType: 'blob'
        })
        .then(response => {
          let dataStr = fn.cutFileName(response.headers["content-disposition"]);
          let format = dataStr.split(".");
          format = format[format.length - 1];
          let url;
          if (response?.headers) {
            if (format == "xlsx") {
              url = window.URL.createObjectURL(new Blob([response.data]));
            } else if (format == "csv") {
              var BOM = "\uFEFF"; // utf-8 ใส่ตัวนี้
              url = window.URL.createObjectURL(new Blob([BOM + response.data]));
            } else {
              alert.error("export file ไม่ได้");
            }
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", dataStr);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(err => {
            console.error(err.message, "message");
            return err.message
        });
        if(typeof resp=='string'){
            return { status :false , data:{}, message:resp }
        }
        else {
            return { status: true, data: resp };   
        }
       } catch (err) {
            console.error(err.message,'message');
       }
  },


  async getOrderExportExcepApi({ commit }, id) {
    try {
        let resp = await axios({
            method: "GET",
            url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/invoice-approvals/${id}/invoice-approvable/export`,
            headers: {
                Authorization:`Bearer ${localStorage.getItem('token')}`,
                Accept: "application/json", 
            },
            timeout: 300000,
            maxContentLength: 1073741824,
            responseType: 'blob'
        })
        .then(response => {
          let dataStr = fn.cutFileName(response.headers["content-disposition"]);
          let format = dataStr.split(".");
          format = format[format.length - 1];
          let url;
          if (response?.headers) {
            if (format == "xlsx") {
              url = window.URL.createObjectURL(new Blob([response.data]));
            } else if (format == "csv") {
              var BOM = "\uFEFF"; // utf-8 ใส่ตัวนี้
              url = window.URL.createObjectURL(new Blob([BOM + response.data]));
            } else {
              alert.error("export file ไมไ่ด้");
            }
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", dataStr);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(err => {
            console.error(err.message, "message");
            return err.message
        });
        if(typeof resp=='string'){
            return { status :false , data:{}, message:resp }
        }
        else {
            return { status: true, data: resp };   
        }
       } catch (err) {
            console.error(err.message,'message');
       }
  },


  async creditNoteExportExcel({ commit }, id) {
    try {
        let resp = await axios({
            method: "GET",
            url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/credit-notes/${id}/credit-note-details/export`,
            headers: {
                Authorization:`Bearer ${localStorage.getItem('token')}`,
                Accept: "application/json", 
            },
            timeout: 300000,
            maxContentLength: 1073741824,
            responseType: 'blob'
        })
        .then(response => {
          let dataStr = fn.cutFileName(response.headers["content-disposition"]);
          let format = dataStr.split(".");
          format = format[format.length - 1];
          let url;
          if (response?.headers) {
            if (format == "xlsx") {
              url = window.URL.createObjectURL(new Blob([response.data]));
            } else if (format == "csv") {
              var BOM = "\uFEFF"; // utf-8 ใส่ตัวนี้
              url = window.URL.createObjectURL(new Blob([BOM + response.data]));
            } else {
              alert.error("export file ไมไ่ด้");
            }
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", dataStr);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(err => {
            console.error(err.message, "message");
            return err.message
        });
        if(typeof resp=='string'){
            return { status :false , data:{}, message:resp }
        }
        else {
            return { status: true, data: resp };   
        }
       } catch (err) {
            console.error(err.message,'message');
       }
  },


};
